import { RekognitionStreamingServiceException as __BaseException } from "./RekognitionStreamingServiceException";
export class AccessDeniedException extends __BaseException {
    constructor(opts) {
        super({
            name: "AccessDeniedException",
            $fault: "client",
            ...opts,
        });
        this.name = "AccessDeniedException";
        this.$fault = "client";
        Object.setPrototypeOf(this, AccessDeniedException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export var ClientChallenge;
(function (ClientChallenge) {
    ClientChallenge.visit = (value, visitor) => {
        if (value.FaceMovementAndLightChallenge !== undefined)
            return visitor.FaceMovementAndLightChallenge(value.FaceMovementAndLightChallenge);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(ClientChallenge || (ClientChallenge = {}));
export const LightChallengeType = {
    SEQUENTIAL: "SEQUENTIAL",
};
export class InternalServerException extends __BaseException {
    constructor(opts) {
        super({
            name: "InternalServerException",
            $fault: "server",
            ...opts,
        });
        this.name = "InternalServerException";
        this.$fault = "server";
        Object.setPrototypeOf(this, InternalServerException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export var LivenessRequestStream;
(function (LivenessRequestStream) {
    LivenessRequestStream.visit = (value, visitor) => {
        if (value.VideoEvent !== undefined)
            return visitor.VideoEvent(value.VideoEvent);
        if (value.ClientSessionInformationEvent !== undefined)
            return visitor.ClientSessionInformationEvent(value.ClientSessionInformationEvent);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(LivenessRequestStream || (LivenessRequestStream = {}));
export var ServerChallenge;
(function (ServerChallenge) {
    ServerChallenge.visit = (value, visitor) => {
        if (value.FaceMovementAndLightChallenge !== undefined)
            return visitor.FaceMovementAndLightChallenge(value.FaceMovementAndLightChallenge);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(ServerChallenge || (ServerChallenge = {}));
export class ServiceQuotaExceededException extends __BaseException {
    constructor(opts) {
        super({
            name: "ServiceQuotaExceededException",
            $fault: "client",
            ...opts,
        });
        this.name = "ServiceQuotaExceededException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ServiceQuotaExceededException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class ServiceUnavailableException extends __BaseException {
    constructor(opts) {
        super({
            name: "ServiceUnavailableException",
            $fault: "server",
            ...opts,
        });
        this.name = "ServiceUnavailableException";
        this.$fault = "server";
        Object.setPrototypeOf(this, ServiceUnavailableException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class ThrottlingException extends __BaseException {
    constructor(opts) {
        super({
            name: "ThrottlingException",
            $fault: "client",
            ...opts,
        });
        this.name = "ThrottlingException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ThrottlingException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class ValidationException extends __BaseException {
    constructor(opts) {
        super({
            name: "ValidationException",
            $fault: "client",
            ...opts,
        });
        this.name = "ValidationException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ValidationException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export var LivenessResponseStream;
(function (LivenessResponseStream) {
    LivenessResponseStream.visit = (value, visitor) => {
        if (value.ServerSessionInformationEvent !== undefined)
            return visitor.ServerSessionInformationEvent(value.ServerSessionInformationEvent);
        if (value.DisconnectionEvent !== undefined)
            return visitor.DisconnectionEvent(value.DisconnectionEvent);
        if (value.ValidationException !== undefined)
            return visitor.ValidationException(value.ValidationException);
        if (value.InternalServerException !== undefined)
            return visitor.InternalServerException(value.InternalServerException);
        if (value.ThrottlingException !== undefined)
            return visitor.ThrottlingException(value.ThrottlingException);
        if (value.ServiceQuotaExceededException !== undefined)
            return visitor.ServiceQuotaExceededException(value.ServiceQuotaExceededException);
        if (value.ServiceUnavailableException !== undefined)
            return visitor.ServiceUnavailableException(value.ServiceUnavailableException);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(LivenessResponseStream || (LivenessResponseStream = {}));
export class SessionNotFoundException extends __BaseException {
    constructor(opts) {
        super({
            name: "SessionNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "SessionNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, SessionNotFoundException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export const LivenessRequestStreamFilterSensitiveLog = (obj) => {
    if (obj.VideoEvent !== undefined)
        return { VideoEvent: obj.VideoEvent };
    if (obj.ClientSessionInformationEvent !== undefined)
        return { ClientSessionInformationEvent: obj.ClientSessionInformationEvent };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const LivenessResponseStreamFilterSensitiveLog = (obj) => {
    if (obj.ServerSessionInformationEvent !== undefined)
        return { ServerSessionInformationEvent: obj.ServerSessionInformationEvent };
    if (obj.DisconnectionEvent !== undefined)
        return { DisconnectionEvent: obj.DisconnectionEvent };
    if (obj.ValidationException !== undefined)
        return { ValidationException: obj.ValidationException };
    if (obj.InternalServerException !== undefined)
        return { InternalServerException: obj.InternalServerException };
    if (obj.ThrottlingException !== undefined)
        return { ThrottlingException: obj.ThrottlingException };
    if (obj.ServiceQuotaExceededException !== undefined)
        return { ServiceQuotaExceededException: obj.ServiceQuotaExceededException };
    if (obj.ServiceUnavailableException !== undefined)
        return { ServiceUnavailableException: obj.ServiceUnavailableException };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const StartFaceLivenessSessionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.LivenessRequestStream && { LivenessRequestStream: "STREAMING_CONTENT" }),
});
export const StartFaceLivenessSessionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.LivenessResponseStream && { LivenessResponseStream: "STREAMING_CONTENT" }),
});
